// Site-wide settings.

// Never-expiring Discord invite link. Discord links and cards stay hidden while this is empty.
export const DISCORD_URL = 'https://discord.gg/BbmCDQXEm2';
// Where the free pre-market brief is posted every weekday morning (the Discord server).
export const BRIEF_URL = DISCORD_URL;

// Google Analytics measurement ID (looks like G-XXXXXXXXXX). Google Analytics and
// the cookie banner stay off while this is empty.
export const GA_MEASUREMENT_ID = 'G-W6H5V4BRN7';


// Social profiles shown in the footer. Icons stay hidden while a link is empty.
export const SOCIAL = {
  x: 'https://x.com/Market_Matrixx',
  instagram: 'https://www.instagram.com/market_matrix_yt/',
  youtube: 'https://www.youtube.com/@MarketMatrix-yt/videos',
  facebook: 'https://www.facebook.com/profile.php?id=100095115318978',
};
